<dx-button (onClick)="this.show()" class="action-btn" height="100%" text="QG" width="100%"></dx-button>

<dx-popup
  (onHidden)="this.onClose()"
  [closeOnOutsideClick]="false"
  [dragEnabled]="true"
  [height]="this.getHeight()"
  [resizeEnabled]="this.isResizable()"
  [shading]="false"
  [showTitle]="true"
  [titleTemplate]="this.isMicroView() ? 'titleTpl' : 'title'"
  [visible]="this.visible"
  [width]="this.getWidth()"
  [wrapperAttr]="{class: this.isMicroView() && this.pinnedStream?.isHistoryMode ? 'qg-popup-micro-history' : 'qg-popup-default'}"
  title="Quote Generator"
>
  <div *dxTemplate="let data of 'titleTpl'" class="window-title">
    <div class="title-text">{{ this.pinnedStream?.ticker }}</div>
    <div class="atm-distance">{{ this.getAtmDistance(this.pinnedStream) }}</div>
    <div class="icons">
      <div class="icon expand">
        <i (click)="this.getOutOfMicroView()" class="fas fa-expand-arrows-alt"></i>
      </div>
      <div class="icon close">
        <i (click)="this.onClose()" class="fas fa-times"></i>
      </div>
    </div>
  </div>
  
  <div #content *dxTemplate="let data of 'content'" class="content">
    
    <div [class.reduced]="this.isReducedView" class="streams">
      <ng-container *ngIf="!this.isReducedView">
        <dx-scroll-view>
          <ng-container *ngFor="let stream of this.streams">
            <ng-container *ngTemplateOutlet="quoteStream; context: {$implicit: stream}"></ng-container>
          </ng-container>
        </dx-scroll-view>
      </ng-container>
      
      <ng-container *ngIf="this.isReducedView">
        <ng-container *ngTemplateOutlet="quoteStream; context: {$implicit: this.pinnedStream}"></ng-container>
      </ng-container>
    </div>
    
    <div *ngIf="!this.isReducedView" class="add-stream-controls">
      
      <fieldset class="fieldset">
        <legend class="legend">Underlying</legend>
        <div>
          <ets-symbol-picker (instrumentSelected)="this.onAddUnderlying($event)"
                             [selectedInstrument]="this.addUnderlying"
                             [showLastPrice]="false">
          </ets-symbol-picker>
        </div>
      </fieldset>
      
      <fieldset class="fieldset option">
        <legend class="legend">
          <dx-check-box (onValueChanged)="this.onAddOptionContractChanged()" [(value)]="this.addOptionContract"
                        [disabled]="!this.isUnderlyingSelected"
                        text="Option"
          ></dx-check-box>
        </legend>
        <div class="inputs">
          <div class="expiration">
            <div class="input">
              <dx-select-box (onValueChanged)="this.onAddExpirationChanged()"
                             [(value)]="this.addExpiration"
                             [disabled]="!this.addOptionContract"
                             [inputAttr]="{style: 'text-align: center;'}"
                             [items]="this.addExpirationList"
                             [showClearButton]="true"
                             displayExpr="dateWithDaysToExpiration"
                             placeholder="Expiration"
              ></dx-select-box>
            </div>
          </div>
          
          <div class="type">
            <div class="input">
              <dx-select-box
                [(value)]="this.addOptionType"
                [disabled]="!this.addOptionContract"
                [inputAttr]="{style: 'text-align: center;'}" [items]="['Call', 'Put']"
                [showClearButton]="true"
                placeholder="Option Type"
              ></dx-select-box>
            </div>
          </div>
          
          <div class="strike">
            <div class="input">
              <ets-strikes-dropdown [(strike)]="this.addStrike"
                                    [disable]="!this.addOptionContract"
                                    [expiration]="this.addExpiration"
                                    [showClearButton]="true"
                                    [targetInstrument]="this.addUnderlying"
              ></ets-strikes-dropdown>
            </div>
          </div>
        </div>
      </fieldset>
      
      
      <div class="add-button">
        <dx-button (onClick)="this.addStream()" height="100%" text="Add" type="default"
        ></dx-button>
      </div>
    </div>
    
    <dx-load-panel [position]="{my: 'center', at: 'center', of: content}"
                   [visible]="this.isLoading && !this.isMicroView()">
    </dx-load-panel>
  </div>

</dx-popup>

<!--Quote Stream Template-->
<ng-template #quoteStream let-stream>

  <!--  Micro View — History mode (2-axis cross pad: vertical = price, horizontal = time) -->
  <div #microHistory *ngIf="this.isMicroView() && stream.mode === 'History'" class="stream-micro history-cross">
    <div (click)="this.onHistoryUpArrowClicked(stream)" class="price-arrow up">
      <i class="fas fa-chevron-up"></i>
    </div>

    <div (click)="this.onLeftArrowClicked(stream)" class="time-arrow left">
      <i class="fas fa-chevron-left"></i>
      <span class="step-label">-{{ stream.jumpStepLabel }}</span>
    </div>

    <div #lastH (click)="this.onLastClicked(stream)" class="last-px">
      <div class="px">{{ stream.lastPrice | number:'1.2-2' }}</div>
      <div class="timestamp">{{ stream.lastTimestamp | date:'EEE dd-MMM HH:mm' }}</div>
      <dx-context-menu
        (onItemClick)="this.onMenuItemClicked(stream, $event)"
        [items]="[{text: 'Reset To Market'}]"
        [target]="lastH"
        [width]="200"
      >
      </dx-context-menu>
    </div>

    <div (click)="this.onRightArrowClicked(stream)" class="time-arrow right">
      <span class="step-label">+{{ stream.jumpStepLabel }}</span>
      <i class="fas fa-chevron-right"></i>
    </div>

    <div (click)="this.onHistoryDownArrowClicked(stream)" class="price-arrow down">
      <i class="fas fa-chevron-down"></i>
    </div>

    <div *ngIf="this.isLoading && this.isMicroView()" class="micro-spinner-plate">
      <div class="dots"><span></span><span></span><span></span></div>
    </div>
  </div>

  <!--  Micro View — non-History (single-row layout, original behavior) -->
  <div #micro *ngIf="this.isMicroView() && stream.mode !== 'History'" class="stream-micro">
    <div (click)="this.onLeftArrowClicked(stream)" *ngIf="stream.mode !== 'Random'"
         [class.navigational]="stream.isNavigationalMode"
         [class.random]="stream.isRandomMode"
         class="arrow left section"
    >
      <i *ngIf="!stream.isNavigationalMode" class="fas fa-chevron-down"></i>
      <i *ngIf="stream.isNavigationalMode" class="fas fa-chevron-left"></i>
    </div>

    <div #last (click)="this.onLastClicked(stream)" [class.random]="stream.isRandomMode" class="last section">
      {{ stream.lastPrice | number:'1.2-2' }}
      <dx-context-menu
        (onItemClick)="this.onMenuItemClicked(stream, $event)"
        [items]="[{text: 'Reset To Market'}]"
        [target]="last"
        [width]="200"
      >
      </dx-context-menu>
    </div>

    <div (click)="this.onRightArrowClicked(stream)" *ngIf="stream.mode !== 'Random'"
         [class.navigational]="stream.isNavigationalMode"
         [class.random]="stream.isRandomMode"
         class="arrow right section"
    >
      <i *ngIf="!stream.isNavigationalMode" class="fas fa-chevron-up"></i>
      <i *ngIf="stream.isNavigationalMode" class="fas fa-chevron-right"></i>
    </div>

    <ng-container *ngIf="stream.mode === 'Random'">
      <div class="section divider">
        <div class="nbsp">&nbsp;</div>
      </div>

      <div class="play-btn">
        <div (click)="this.toggleStreamRunning(stream)" class="play-stop">
          <i *ngIf="!stream.isRunning" class="fas fa-play fa-lg icon" style="color: green;"></i>
          <i *ngIf="stream.isRunning" class="fas fa-stop fa-lg icon" style="color: red;"></i>
        </div>
      </div>

    </ng-container>

    <div *ngIf="this.isLoading && this.isMicroView()" class="micro-spinner-plate">
      <div class="dots"><span></span><span></span><span></span></div>
    </div>
  </div>

  <fieldset *ngIf="!this.isMicroView()" class="stream">

    <legend class="title">
      <div class="ticker">
        {{ stream.tickerDisplayName }}
      </div>

      <div class="icons">
        <div class="compress-expand icon">
          <div (click)="this.toggleExpandStream(stream)" *ngIf="!this.isReducedView" class="compress-icon">
            <i class="fas fa-expand-arrows-alt"></i>
          </div>

          <div (click)="this.toggleExpandStream()" *ngIf="this.isReducedView" class="compress-icon">
            <i class="fas fa-expand-arrows-alt"></i>
          </div>
        </div>

        <div (click)="this.toggleStreamMicroView(stream)" *ngIf="this.isReducedView" class="compress-icon">
          <i class="fas fa-compress"></i>
        </div>

        <div (click)="this.removeStream(stream)" *ngIf="!this.isReducedView" class="remove-icon">
          <i class="fas fa-times fa-lg"></i>
        </div>

        <div (click)="this.toggleVerticalView()" class="icon" *ngIf="this.isReducedView">
          <i class="fas fa-sync-alt"></i>
        </div>

      </div>
    </legend>

    <div class="body" [class.vertical]="this.isVerticalView">

      <ng-container *ngIf="stream.mode === 'History'">
        <div class="section history-up-down">
          <div (click)="this.onHistoryDownArrowClicked(stream)" class="arrow left section">
            <img alt="Tick Down" height="32px" src="/assets/red-arrow-down.png" width="32px">
          </div>

          <div class="row atm" (click)="this.onHistoryAtmClicked(stream)">
            <div class="number">
              ${{ stream.historyDelta }}
            </div>
          </div>

          <div (click)="this.onHistoryUpArrowClicked(stream)" class="arrow right section">
            <img alt="Tick Up" height="32px" src="/assets/green-arrow-up.png" width="32px">
          </div>
        </div>
        <!-- Separators -->
        <ng-container>
          <ng-container *ngIf="this.isVerticalView">
            <div class="section divider" [class.vertical]="this.isVerticalView">
              <div class="nbsp">
                <hr/>
              </div>
            </div>
          </ng-container>
          <ng-container *ngIf="!this.isVerticalView">
            <div class="section divider">
              <div class="nbsp">&nbsp;</div>
            </div>
          </ng-container>
        </ng-container>
      </ng-container>

      <div class="navigation section">

        <div *ngIf="stream.isShowingAtm" class="row atm">
          <div class="number">
            {{ (this.getAtmDistance(stream)) }}
          </div>

        </div>

        <div class="row upper">
          <div (click)="this.onLeftArrowClicked(stream)" [class.navigational]="stream.isNavigationalMode"
               [class.random]="stream.isRandomMode"
               class="arrow left section"
          >
            <img *ngIf="!stream.isNavigationalMode" alt="Tick Down" height="32px" src="/assets/red-arrow-down.png"
                 width="32px">
            <i *ngIf="stream.isNavigationalMode" class="fas fa-caret-left fa-lg big"></i>
          </div>

          <div class="section last">
            <div #last (click)="this.onLastClicked(stream)" [class.random]="stream.isRandomMode" class="last-px">
              {{ stream.lastPrice | number:'1.2-2' }}
              <dx-context-menu
                (onItemClick)="this.onMenuItemClicked(stream, $event)"
                (onShowing)="this.onMenuShowing(stream)"
                [itemTemplate]="'item'"
                [items]="stream.menuItems"
                [target]="last"
                [width]="200"
              ></dx-context-menu>
            </div>
          </div>

          <div (click)="this.onRightArrowClicked(stream)" [class.navigational]="stream.isNavigationalMode"
               [class.random]="stream.isRandomMode"
               class="arrow right section"
          >
            <img *ngIf="!stream.isNavigationalMode" alt="Tick Up" height="32px" src="/assets/green-arrow-up.png"
                 width="32px">
            <i *ngIf="stream.isNavigationalMode" class="fas fa-caret-right fa-lg big"></i>
          </div>
        </div>

        <div *ngIf="stream.mode === 'History'" class="row bottom">
          <div class="timestamp">
            {{ stream.lastTimestamp | date:'EEE dd-MMM-yy hh:mm:ss aaa' }}
          </div>
        </div>

        <div *ngIf="stream.isShowingAtm && stream.mode !== 'History'" class="row bottom">
          <div (click)="this.resetToMarketPrice(stream)" class="market-atm">
            {{ this.getAtm(stream) | number }}
          </div>
        </div>

      </div>

      <!-- Separators -->
      <ng-container>
        <ng-container *ngIf="this.isVerticalView">
          <div class="section divider" [class.vertical]="this.isVerticalView">
            <div class="nbsp">
              <hr/>
            </div>
          </div>
        </ng-container>
        <ng-container *ngIf="!this.isVerticalView">
          <div class="section divider">
            <div class="nbsp">&nbsp;</div>
          </div>
        </ng-container>
      </ng-container>

      <div [class.shortened]="this.isManualView(stream) || this.isHistoryView(stream)" class="modes section">

        <div class="stream-mode">
          <div class="mode">
            <dx-select-box (onValueChanged)="this.setMode(stream, $event.value)"
                           [(value)]="stream.mode"
                           [disabled]="!this.canChangeMode(stream)"
                           [inputAttr]="{style: 'text-align: center;'}"
                           [items]="['Manual', 'Random', 'History', 'Script']"
                           placeholder="Mode"
            ></dx-select-box>
          </div>
        </div>

        <div class="quote-source">
          <div class="quote-source">
            <dx-select-box (onValueChanged)="this.setQuoteSource(stream, $event.value)"
                           [(value)]="stream.quoteSource"
                           [disabled]="!this.canChangeQuoteSource(stream)"
                           [inputAttr]="{style: 'text-align: center;'}"
                           [items]="stream.quoteSourceList"
                           placeholder="Source"
            ></dx-select-box>
          </div>
        </div>

      </div>

      <ng-container *ngIf="!this.isManualView(stream) && !this.isHistoryView(stream)">
        <ng-container>
          <ng-container *ngIf="this.isVerticalView">
            <div class="section divider" [class.vertical]="this.isVerticalView">
              <div class="nbsp">
                <hr/>
              </div>
            </div>
          </ng-container>
          <ng-container *ngIf="!this.isVerticalView">
            <div class="section divider">
              <div class="nbsp">&nbsp;</div>
            </div>
          </ng-container>
        </ng-container>

        <div [class.disabled]="stream.isManualMode" class="automatic section">
          <div (click)="this.toggleStreamRunning(stream)" class="play-stop">
            <i *ngIf="!stream.isRunning" class="fas fa-play fa-lg icon" style="color: green;"></i>
            <i *ngIf="stream.isRunning" class="fas fa-stop fa-lg icon" style="color: red;"></i>
          </div>

          <div class="speed">
            <dx-slider (onValueChanged)="this.changeStreamFrequency(stream)"
                       [(value)]="stream.frequency"
                       [disabled]="stream.isManualMode"
                       [max]="1000"
                       [min]="1"
                       [rtlEnabled]="false"
            ></dx-slider>
          </div>
        </div>
      </ng-container>

      <!-- Separators -->
      <ng-container>
        <ng-container *ngIf="this.isVerticalView">
          <div class="section divider" [class.vertical]="this.isVerticalView">
            <div class="nbsp">
              <hr/>
            </div>
          </div>
        </ng-container>
        <ng-container *ngIf="!this.isVerticalView">
          <div class="section divider">
            <div class="nbsp">&nbsp;</div>
          </div>
        </ng-container>
      </ng-container>

      <div class="specific-controls section" [class.vertical]="this.isVerticalView">
        <ng-container [ngSwitch]="stream.mode">
          <ng-container *ngSwitchCase="'Manual'">
            <ng-container *ngTemplateOutlet="manualSpecificControls; context: {$implicit: stream}">
            </ng-container>
          </ng-container>
          <ng-container *ngSwitchCase="'Random'">
            <ng-container *ngTemplateOutlet="randomSpecificControls; context: {$implicit: stream}">
            </ng-container>
          </ng-container>
          <ng-container *ngSwitchCase="'History'">
            <ng-container *ngTemplateOutlet="historySpecificControls; context: {$implicit: stream}">
            </ng-container>
          </ng-container>
          <ng-container *ngSwitchCase="'Script'">
            <ng-container *ngTemplateOutlet="scriptSpecificControls; context: {$implicit: stream}">
            </ng-container>
          </ng-container>
          <ng-container *ngSwitchDefault>
            <div class="div">
              N/A
            </div>
          </ng-container>
        </ng-container>
      </div>

    </div>

  </fieldset>

</ng-template>

<!--Manual Specific Controls-->
<ng-template #manualSpecificControls let-stream>
  <div [class.shortened]="this.isManualView(stream)" class="manual" [class.vertical]="this.isVerticalView">

    <div class="element quote-step">
      <div *ngIf="!this.isManualView(stream)" class="label">Quote Step</div>
      <div class="input">
        <div class="down">
          <dx-button (onClick)="this.decrementStepSize(stream)" text="-"></dx-button>
        </div>
        <div class="value">
          <dx-select-box [(value)]="stream.quoteStep"
                         [acceptCustomValue]="true"
                         [inputAttr]="{style: 'text-align: center;'}"
                         [items]="stream.quoteStepList"
                         [searchEnabled]="true"
          ></dx-select-box>
        </div>
        <div class="up">
          <dx-button (onClick)="this.incrementStepSize(stream)" text="+"></dx-button>
        </div>
      </div>
    </div>

    <div class="element punch-box">
      <div class="row">
        <div class="btn">
          <dx-button (onClick)="this.setQuoteStep(stream,1)" text="1" width="100%"></dx-button>
        </div>
        <div class="btn">
          <dx-button (onClick)="this.setQuoteStep(stream,5)" text="5" width="100%"></dx-button>
        </div>
        <div class="btn">
          <dx-button (onClick)="this.setQuoteStep(stream, 10)" text="10" width="100%"></dx-button>
        </div>
      </div>
      <div class="row">
        <div class="btn">
          <dx-button (onClick)="this.setQuoteStep(stream,25)" text="25" width="100%"></dx-button>
        </div>
        <div class="btn">
          <dx-button (onClick)="this.setQuoteStep(stream,50)" text="50" width="100%"></dx-button>
        </div>
        <div class="btn">
          <dx-button (onClick)="this.setQuoteStep(stream,100)" text="100" width="100%"></dx-button>
        </div>
      </div>
    </div>
  </div>
</ng-template>

<!--Random Specific Controls-->
<ng-template #randomSpecificControls let-stream>
  <div class="random" [class.vertical]="this.isVerticalView">
    
    <div class="speed">
      <div class="label">Trend Bias</div>
      
      <div class="input">
        <div class="trend">
          Bearish
        </div>
        <div class="slider">
          <dx-slider (onValueChanged)="this.onTrendBiasChanged(stream)" [(value)]="stream.trendBias" [max]="100" [min]="-100"
                     [rtlEnabled]="false">
          </dx-slider>
        </div>
        <div class="trend">
          Bullish
        </div>
      </div>
    
    </div>
    
    <div class="element quote-step">
      <div class="label">Quote Step</div>
      <div class="input">
        <dx-select-box [(value)]="stream.quoteStep"
                       [acceptCustomValue]="true"
                       [inputAttr]="{style: 'text-align: center;'}"
                       [items]="stream.quoteStepList"
                       [searchEnabled]="true"
        ></dx-select-box>
      </div>
    </div>
  </div>
</ng-template>

<!--History Specific Controls-->
<ng-template #historySpecificControls let-stream>
  <div class="history" [class.vertical]="this.isVerticalView">
    
    <div class="dataset-controls">
      <div class="block dataset">
        <div class="jump-to field">
          <div class="label">Start Point</div>
          <div class="input">
            <dx-date-box
              (onValueChanged)="this.onJumpToDateChanged(stream)"
              [(value)]="stream.jumpToDate"
              [disabledDates]="stream.dataset?.nonTradingDates"
              [disabled]="!stream.isDatasetSelected"
              [displayFormat]="'EEE, dd-MMM-yy HH:mm a'"
              [min]="this.getMinDate(stream)"
              [max]="this.getMaxDateForJump(stream)"
              [showAnalogClock]="false"
              dateSerializationFormat="yyyy-MM-ddTHH:mm:00"
              type="datetime"
            ></dx-date-box>
          </div>
        </div>
      </div>
      
      <div class="block punch-pad">
        <div class="row jump-step" [class.vertical]="this.isVerticalView">
          <dx-select-box (onValueChanged)="this.onJumpStepChanged(stream)"
                         [(value)]="stream.jumpStep"
                         [disabled]="!stream.isDatasetSelected"
                         [displayExpr]="'step'"
                         [inputAttr]="{style: 'text-align: center'}"
                         [items]="stream.jumpStepList"
                         [valueExpr]="'value'"
                         width="100%"
          ></dx-select-box>
        </div>
        
        <div class="row numbers">
          <div class="btn">
            <dx-button (onClick)="this.changeJumpStep(stream,1)" [disabled]="!stream.isDatasetSelected" text="1m"
                       width="100%"></dx-button>
          </div>
          <div class="btn">
            <dx-button (onClick)="this.changeJumpStep(stream,5)" [disabled]="!stream.isDatasetSelected" text="5m"
                       width="100%"></dx-button>
          </div>
          <div class="btn">
            <dx-button (onClick)="this.changeJumpStep(stream, 15)" [disabled]="!stream.isDatasetSelected" text="15m"
                       width="100%"></dx-button>
          </div>
        </div>
        
        <div class="row numbers">
          <div class="btn">
            <dx-button (onClick)="this.changeJumpStep(stream,30)" [disabled]="!stream.isDatasetSelected" text="30m"
                       width="100%"></dx-button>
          </div>
          <div class="btn">
            <dx-button (onClick)="this.changeJumpStep(stream,60)" [disabled]="!stream.isDatasetSelected" text="1h"
                       width="100%"></dx-button>
          </div>
          <div class="btn">
            <dx-button (onClick)="this.changeJumpStep(stream,1440)" [disabled]="!stream.isDatasetSelected" text="1d"
                       width="100%"></dx-button>
          </div>
        </div>
      </div>

      <!-- Separators -->
      <ng-container>
        <ng-container *ngIf="this.isVerticalView">
          <div class="section divider" [class.vertical]="this.isVerticalView">
            <div class="nbsp"><hr/></div>
          </div>
        </ng-container>
        <ng-container *ngIf="!this.isVerticalView">
          <div class="section divider">
            <div class="nbsp">&nbsp;</div>
          </div>
        </ng-container>
      </ng-container>

      <div class="block up-down">
        <div class="element quote-step">
          <div *ngIf="!this.isManualView(stream)" class="label">Quote Step</div>
          <div class="input">
            <div class="btn down">
              <dx-button width="100%" (onClick)="this.decrementStepSize(stream)" text="-"></dx-button>
            </div>
            <div class="value">
              <dx-select-box [(value)]="stream.quoteStep"
                             [acceptCustomValue]="true"
                             [inputAttr]="{style: 'text-align: center;'}"
                             [items]="stream.quoteStepList"
                             [searchEnabled]="true"
                             width="100%"
              ></dx-select-box>
            </div>
            <div class="btn up">
              <dx-button width="100%" (onClick)="this.incrementStepSize(stream)" text="+"></dx-button>
            </div>
          </div>
        </div>
        <div class="element punch-box">
          <div class="row">
            <div class="btn">
              <dx-button (onClick)="this.setQuoteStep(stream,1)" text="1" width="100%"></dx-button>
            </div>
            <div class="btn">
              <dx-button (onClick)="this.setQuoteStep(stream,5)" text="5" width="100%"></dx-button>
            </div>
            <div class="btn">
              <dx-button (onClick)="this.setQuoteStep(stream, 10)" text="10" width="100%"></dx-button>
            </div>
          </div>
          <div class="row">
            <div class="btn">
              <dx-button (onClick)="this.setQuoteStep(stream,25)" text="25" width="100%"></dx-button>
            </div>
            <div class="btn">
              <dx-button (onClick)="this.setQuoteStep(stream,50)" text="50" width="100%"></dx-button>
            </div>
            <div class="btn">
              <dx-button (onClick)="this.setQuoteStep(stream,100)" text="100" width="100%"></dx-button>
            </div>
          </div>
        </div>
      </div>
    </div>

  </div>
</ng-template>

<!--Script Specific Controls-->
<ng-template #scriptSpecificControls let-stream>
  
  <div class="script" [class.vertical]="this.isVerticalView">
    
    <div class="selectors">
      <div class="open button">
        <div (click)="this.showSavedScriptSelector(stream)" class="icon">
          <div><i class="fas fa-folder-open fa-lg"></i></div>
          <div class="label">Open Script</div>
        </div>
        <div class="dataset-name">
          "{{ (stream.savedScript?.name || '&lt;Not Selected&gt;') }}"
        </div>
      </div>
      
      <div class="provide button">
        <div (click)="this.showCustomScriptInput(stream)" class="icon"><i class="fas fa-keyboard fa-lg"></i></div>
        <div class="label">Custom Script</div>
        <div (click)="this.saveCustomScript(stream)" *ngIf="stream.customScript" class="icon">
          <i class="fas fa-save fa-lg" style="color: green; margin-top: 1px"></i>
        </div>
      </div>
    </div>
    
    <div class="quote-step">
      <div class="label">Tick Size</div>
      <div class="input">
        <dx-select-box [(value)]="stream.quoteStep"
                       [acceptCustomValue]="true"
                       [inputAttr]="{style: 'text-align: center;'}"
                       [items]="stream.quoteStepList"
                       [searchEnabled]="true"
        ></dx-select-box>
      </div>
    </div>
  </div>

</ng-template>

<ets-dataset-selector></ets-dataset-selector>

<ets-custom-script-input></ets-custom-script-input>

<ets-custom-script-save></ets-custom-script-save>
